import React from 'react';
import { useTranslation } from 'react-i18next';
import { Dropdown, DropdownV2, Input } from '../../../../../UI/Common';
import ReactSelect from '../../../../../UI/ReactSelect';

const divStyle = {
  marginTop: 10,
  marginBottom: 15,
  backgroundColor: 'rgba(0,0,0,.1)',
  width: '100%',
  height: 1,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
};
const tagLocation = ['None', 'Top', 'Right', 'Bottom', 'Left', 'Center'];
const CirclePropertiesForm = ({
  values: { position, dimension, ...values },
  handleChange,
  setFieldValue,
  touched,
  errors,
  sensors,
}) => {
  const { t } = useTranslation('app');
  const tagLocGenerator = () => {
    let result = [];
    tagLocation.forEach((loc) => {
      const tagLoc = {
        value: loc,
        label: loc,
      };
      result.push(tagLoc);
    });
    return result;
  };
  function getSensorName(sensorId) {
    const index = sensors.findIndex((sensor) => sensor.sensorId === sensorId);
    return sensors[index].name;
  }
  function displayFormat(sensorId) {
    const result = sensors.filter((sensor) => sensor.sensorId === sensorId)[0];
    if (!result) return '';
    const groupName = result.groupName.trim();
    const sensorName = result.name.trim();
    return `(${groupName}) ${sensorName}`;
  }
  return (
    <>
      <div className="position-relative">
        <div style={divStyle}>
          <span
            style={{
              fontSize: 16,
              fontWeight: '500',
              backgroundColor: 'white',
              padding: '0px 5px',
            }}
          >
            {t('Tag properties')}
          </span>
        </div>
        <div className="d-flex flex-row">
          <DropdownV2.Selection
            translate
            label="Tag Location"
            data={tagLocGenerator()}
            value={values.tagLocation}
            onChange={(location) => setFieldValue('tagLocation', location)}
            containerProps={{
              style: { width: '75%' },
            }}
            toggleProps={{
              style: { width: '100%' },
            }}
          />
          <Input
            id="tagBoxSize"
            // type="number"
            label="Tag Box Size %"
            labelStyle={{ whiteSpace: 'nowrap' }}
            onChange={handleChange('tagBoxSize')}
            onFocus={(e) => e.target.select()}
            value={values.tagBoxSize}
          />
        </div>
        <div className="d-flex flex-row">
          <Input
            id="tagText"
            label="Tag Text"
            onChange={handleChange('tagText')}
            onFocus={(e) => e.target.select()}
            value={values.tagText}
          />
          <Input
            id="tagFontSize"
            // type="number"
            label="Font Size"
            onChange={handleChange('tagFontSize')}
            onFocus={(e) => e.target.select()}
            value={values.tagFontSize}
          />
        </div>
        <div className="d-flex flex-row">
          <Input
            id="tagFontName"
            label="Font"
            onChange={handleChange('tagFontName')}
            onFocus={(e) => e.target.select()}
            value={values.tagFontName}
          />
          <Input
            id="tagTextColor"
            label="Color"
            onChange={handleChange('tagTextColor')}
            onFocus={(e) => e.target.select()}
            value={values.tagTextColor}
          />
        </div>
        <Input
          id="tagBackGroundColor"
          containerStyle={{ marginBottom: 25 }}
          label="Background Color"
          onChange={handleChange('tagBackGroundColor')}
          onFocus={(e) => e.target.select()}
          value={values.tagBackGroundColor}
        />
      </div>
      <ReactSelect
        label="Sensor"
        options={sensors}
        value={values.sensorId}
        onChange={({ value }) => {
          setFieldValue('sensorId', value);
          setFieldValue('sensorName', getSensorName(value));
        }}
        valueKey="sensorId"
        labelKey="name"
        getOptionLabel={(obj) => `(${obj.groupName}) ${obj.name}`}
        singleValueStyle={{ whiteSpace: 'break-word' }}
      />
    </>
  );
};

export default CirclePropertiesForm;
